/**
 * Custom Announcement Bar Enhancements - Fixed Version
 * 1. Slide-up animation instead of fade
 * 2. Expanded clickable areas for slides containing links
 * 3. Fixed positioning issues
 */
document.addEventListener('DOMContentLoaded', function() {
  // First, add special styling to prevent ANY animations during page load
  const initialStyle = document.createElement('style');
  initialStyle.id = 'announcement-initial-style';
  initialStyle.textContent = `
    /* Prevent ANY animations during initial page load */
    .announcement__slider.flickity-enabled .flickity-slider,
    .announcement__slider.flickity-enabled .announcement__slide {
      transition: none !important;
      animation: none !important;
    }
    
    /* Force the first slide to be fully visible immediately */
    .announcement__slider.flickity-enabled .announcement__slide.is-selected {
      opacity: 1 !important;
      transform: none !important;
      left: 0 !important;
    }
    
    /* Fix positioning issues */
    .announcement__slider .flickity-slider {
      transform: none !important;
      left: 0 !important;
    }
    
    /* Expanded clickable area styles */
    .announcement__slide.is-clickable {
      cursor: pointer;
      position: relative;
    }
    
    /* Make the entire slide a clickable area by adding an overlay */
    .announcement__slide.is-clickable::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
    }
    
    /* Prevent the overlay from blocking actual links */
    .announcement__slide.is-clickable a {
      position: relative;
      z-index: 4;
    }
    
    /* Preserve pointer events on arrows */
    .announcement__bar-holder--arrows .announcement__slider .flickity-prev-next-button {
      z-index: 5;
      pointer-events: auto;
    }
    
    /* Add a subtle hover effect */
    .announcement__slide.is-clickable:hover::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.05);
      pointer-events: none;
      z-index: 2;
    }
  `;
  document.head.appendChild(initialStyle);
  
  // Main function to initialize our custom animation
  function initSlideUpAnimation() {
    // Remove the initial style after a short delay
    setTimeout(() => {
      const initialStyleEl = document.getElementById('announcement-initial-style');
      if (initialStyleEl) initialStyleEl.remove();
    }, 500);
    
    // Add our permanent slide-up animation styles
    const customStyle = document.createElement('style');
    customStyle.textContent = `
      /* Fix for positioning issues */
      .flickity-viewport {
        overflow: hidden !important;
      }
      
      /* Main animation styles */
      .announcement__slider .flickity-slider {
        transform: none !important;
        left: 0 !important;
      }
      
      .announcement__slider .announcement__slide {
        left: 0 !important;
        opacity: 0;
        transform: translateY(30px) !important;
        transition: transform 0.4s ease, opacity 0.4s ease !important;
        z-index: 1;
        width: 100% !important;
      }
      
      .announcement__slider .announcement__slide.is-selected {
        opacity: 1;
        transform: translateY(0) !important;
        z-index: 2;
      }
      
      /* Container styling */
      .announcement__bar-holder--slider {
        overflow: hidden;
      }
      
      /* Ensure proper placement */
      .flickity-enabled.is-draggable .flickity-viewport {
        touch-action: pan-y;
      }
    `;
    document.head.appendChild(customStyle);
    
    // Process all sliders
    document.querySelectorAll('.announcement__slider[data-slider]').forEach(slider => {
      if (!slider.classList.contains('flickity-enabled')) return;
      
      const flkty = Flickity.data(slider);
      if (!flkty) return;
      
      // Store the current index
      const currentIndex = flkty.selectedIndex;
      
      // Disable the fade option and fix positioning
      flkty.options.fade = false;
      flkty.options.wrapAround = true; // Enable wrap around for better transitions
      
      // Set initial position explicitly
      flkty.x = 0;
      flkty.viewport.style.transform = 'translateX(0)';
      
      // Reset positions for all slides
      flkty.slides.forEach(slide => {
        slide.target = 0;
        slide.cells[0].element.style.left = '0';
      });
      
      // Flag to track if this is the first transition after page load
      let isFirstTransition = true;
      
      // Override the select method
      const originalSelect = flkty.select;
      flkty.select = function(index, isWrapped, isInstant) {
        // For the first transition after page load, force instant to be true
        if (isFirstTransition && !isInstant) {
          isInstant = true;
          isFirstTransition = false;
        }
        
        // Call the original method
        originalSelect.call(this, index, isWrapped, isInstant);
        
        // If instant, skip animations
        if (isInstant) return;
        
        // Apply our custom animation
        const slides = this.slides;
        slides.forEach(slide => {
          const element = slide.cells[0].element;
          
          if (slide.target === this.x && !element.classList.contains('is-selected')) {
            // Prepare new slide for animation
            element.style.transform = 'translateY(30px)';
            element.style.opacity = '0';
            element.style.left = '0'; // Ensure left is always 0
            
            // Trigger reflow
            element.offsetHeight;
            
            // Animate in
            element.style.transform = '';
            element.style.opacity = '';
          }
        });
        
        // After slide change, process for clickable areas
        processSlides();
      };
      
      // Override repositionSlides to prevent horizontal movement
      const originalRepositionSlides = flkty.repositionSlides;
      flkty.repositionSlides = function() {
        originalRepositionSlides.call(this);
        
        // Force all slides to be at the same horizontal position
        this.slides.forEach(slide => {
          slide.target = 0;
          slide.cells[0].element.style.left = '0';
        });
      };
      
      // Fix viewport position
      flkty.viewport.style.transform = 'translateX(0)';
      
      // Rebuild cells to apply our changes
      flkty.reloadCells();
      
      // Force select the current slide with instant=true to avoid animation
      flkty.select(currentIndex, false, true);
      
      // Additional fix for initial positioning
      setTimeout(() => {
        flkty.x = 0;
        flkty.viewport.style.transform = 'translateX(0)';
        flkty.slides.forEach(slide => {
          slide.target = 0;
          slide.cells[0].element.style.left = '0';
        });
      }, 100);
    });
  }
  
  // Process all announcement slides to make them fully clickable
  function processSlides() {
    document.querySelectorAll('.announcement__slide').forEach(slide => {
      // Skip if already processed
      if (slide.classList.contains('processed-for-clickable')) return;
      slide.classList.add('processed-for-clickable');
      
      // Look for links within the slide
      const link = slide.querySelector('a');
      if (!link) return;
      
      // Get link attributes
      const href = link.getAttribute('href');
      const target = link.getAttribute('target') || '_self';
      
      // Mark slide as clickable
      slide.classList.add('is-clickable');
      slide.setAttribute('data-href', href);
      slide.setAttribute('data-target', target);
      
      // Add click handler to the entire slide
      slide.addEventListener('click', function(e) {
        // Don't trigger if clicking on the arrows or the actual link
        if (e.target.closest('.flickity-prev-next-button, a')) return;
        
        // Get the attributes from the slide
        const linkHref = this.getAttribute('data-href');
        const linkTarget = this.getAttribute('data-target');
        
        // Navigate to the link
        if (linkTarget === '_blank') {
          window.open(linkHref, '_blank');
        } else {
          window.location.href = linkHref;
        }
      });
    });
  }
  
  // Wait for Flickity to be loaded and initialized
  function checkFlickity() {
    if (typeof Flickity !== 'undefined' && 
        document.querySelector('.announcement__slider.flickity-enabled')) {
      initSlideUpAnimation();
      processSlides();
    } else {
      setTimeout(checkFlickity, 50);
    }
  }
  
  checkFlickity();
  
  // Set up a mutation observer to watch for slides being added or changed
  const observer = new MutationObserver(function(mutations) {
    processSlides();
  });
  
  // Watch announcement wrappers for changes
  document.querySelectorAll('.announcement__wrapper').forEach(wrapper => {
    observer.observe(wrapper, {
      childList: true,
      subtree: true
    });
  });
  
  // Listen for theme events
  document.addEventListener('theme:slider:loaded', function() {
    setTimeout(() => {
      initSlideUpAnimation();
      processSlides();
    }, 50);
  });
  
  document.addEventListener('theme:announcement:init', function() {
    setTimeout(() => {
      processSlides();
    }, 50);
  });
});